import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/sectors", label: "Sectors" },
  { to: "/experience", label: "Experience" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header className="sticky top-0 z-50 border-b border-brand-line bg-white/90 backdrop-blur-md">
      <div className="wrap flex h-20 items-center justify-between gap-4 md:h-28">
        <Link to="/" className="flex items-center" data-testid="header-logo-link" aria-label="SafetySymbiosis home">
          <img
            src="/safetysymbiosis-logo.png"
            alt="SafetySymbiosis — Environment | Health | Safety"
            className="h-16 w-auto md:h-24"
            width={1640}
            height={959}
          />
        </Link>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Primary">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `nav-link ${isActive ? "nav-link-active" : ""}`
              }
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            className="btn-navy !px-5 !py-2.5"
            data-testid="nav-cta-get-in-touch"
          >
            Get in Touch
          </Link>
        </nav>

        <button
          className="rounded-lg p-2 text-brand-navy transition-colors hover:bg-brand-mist lg:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          data-testid="header-mobile-menu-button"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-brand-line bg-white lg:hidden">
          <nav className="wrap flex flex-col gap-1 py-4" aria-label="Mobile">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                className={({ isActive }) =>
                  `rounded-lg px-3 py-3 text-base font-medium transition-colors ${
                    isActive
                      ? "bg-brand-green/10 text-brand-greendeep"
                      : "text-brand-charcoal hover:bg-brand-mist"
                  }`
                }
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              className="btn-navy mt-3 w-full"
              data-testid="mobile-nav-cta-get-in-touch"
            >
              Get in Touch
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
